import { Typography } from '@material-ui/core';
import styled from 'styled-components';

export const Description = styled(Typography)`
&.MuiTypography-root {
  font-size: 14px;
  font-family: 'Nunito', sans-serif;
  width: 75%;
  font-weight: bold;
}
`;

export const styles = {
  cardIcon: {
    width: '300px',
  },
  emptyContainer: {
    alignItems: 'center',
    paddingBottom: '40px'
  },
  cardBody: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  dateContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '25%',
  },
  date: {
    fontSize: '12px',
    color: 'gray',
    fontFamily: 'Nunito , sans-serif',
  },
  rejectContainer: {
    width: '70%',
    border: '1px solid #FFA500',
    borderRadius: '10px',
    padding: '5px',
    backgroundColor: '#e9e9e9',
  },
  rejectTitle: {
    fontSize: '16px',
    fontFamily: 'Nunito , sans-serif',
    fontWeight: 'bold',
  },
  rejectDescription: {
    fontSize: '14px',
    fontFamily: 'Nunito , sans-serif',
  },
};

// export const ImgWrapper = styled.div`
//   display: block;
//   overflow: hidden;
//   padding: 56.25% 0 0 0;
//   position: relative;
//   width: 500px;
// `;

// export const Img = styled.img`
//   position: absolute;
//   top: 0;
//   width: 100%;
//   margin: 10px 0px;
// `;
